import React from 'react'
import { IoTrash } from 'react-icons/io5'

interface DonorRemoveButtonProps {
  onRemove: () => void
}

const DonorRemoveButton: React.FC<DonorRemoveButtonProps> = ({ onRemove }) => {
  return (
    <button
      className="donor-card__remove-btn"
      onClick={onRemove}
      aria-label="Remover doador"
    >
      <IoTrash />
    </button>
  )
}

export default DonorRemoveButton
